import React from "react";

export default function Architecture() {
  const steps = [
    {
      title: "Employer Funds Platform",
      description: "USD contributions are converted into BENE tokens pegged 1:1.",
      border: "border-blue-600",
      bg: "bg-blue-50"
    },
    {
      title: "Smart Contracts Govern Access",
      description: "Usage rules, expirations, and vendor access coded in.",
      border: "border-purple-600",
      bg: "bg-purple-50"
    },
    {
      title: "Employees Use BENE Tokens",
      description: "Non-custodial wallets give employees control and transparency.",
      border: "border-green-600",
      bg: "bg-green-50"
    },
    {
      title: "Vendors Get Paid Instantly",
      description: "Fulfilled contracts auto-trigger vendor payments and invoicing.",
      border: "border-orange-600",
      bg: "bg-orange-50"
    },
    {
      title: "AI Guides Every Interaction",
      description: "Natural language agents help onboard and support employees.",
      border: "border-indigo-600",
      bg: "bg-indigo-50"
    },
    {
      title: "Real-Time Data Feeds In",
      description: "Claims and census data drive PBM and stop-loss optimization.",
      border: "border-teal-600",
      bg: "bg-teal-50"
    }
  ];

  return (
    <section className="bg-white py-20 px-6" id="architecture">
      <div className="max-w-6xl mx-auto text-center">
        <h2 className="text-3xl md:text-4xl font-bold mb-6">
          How BenefitChain Works
        </h2>
        
        <p className="text-gray-600 text-lg max-w-3xl mx-auto">
          A secure, tokenized ecosystem that connects employers, employees, and vendors through smart contracts and AI-enhanced automation.
        </p>

        <div className="grid md:grid-cols-3 gap-8 text-left mt-12">
          {steps.map((step, index) => (
            <div
              key={index}
              className={`p-6 border-l-4 ${step.border} ${step.bg} rounded-r-lg hover:shadow-md transition-shadow`}
            >
              <h3 className="text-xl font-semibold mb-2 text-gray-800">
                {step.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {step.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
} 